var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_Promise.js
// module id = 3974
// module chunks = 168707334958949